import { oc } from "@orpc/contract";
import { z } from "zod";

export const VoiceCallTicketSchema = z.object({
  /** Opaque, signed, short-lived. Present it as the `ticket` query parameter
   * when opening `wsPath`. */
  ticket: z.string(),
  /** Same-origin path of the voice-call WebSocket, relative to the API base. */
  wsPath: z.string(),
  expiresAt: z.date(),
});

export const voiceCallContracts = {
  /**
   * Mint a ticket authorizing one chat-agent voice-call WebSocket. The socket
   * cannot use the session cookie (a WS handshake is not covered by CORS); this
   * call is, so only a first-party page can obtain a ticket.
   */
  mintTicket: oc.output(VoiceCallTicketSchema).route({
    method: "POST",
    path: "/ai/voice-call/ticket",
    summary: "Mint a voice-call ticket",
    description:
      "Mints a 30-second signed ticket that authorizes one assistant voice-call WebSocket for the current user, returning the ticket, the socket path and its expiry.",
  }),
};

export type VoiceCallTicket = z.infer<typeof VoiceCallTicketSchema>;
